import { render, staticRenderFns } from "./SkupDetails.vue?vue&type=template&id=a0c50a5a&scoped=true&"
import script from "./SkupDetails.vue?vue&type=script&lang=js&"
export * from "./SkupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c50a5a",
  null
  
)

export default component.exports